import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';

function DocsNav() {
  const location = useLocation();
  
  const sections = [
    {
      title: "Getting Started",
      items: [
        { path: "/docs/installation", label: "Installation" },
        { path: "/docs/configuration", label: "Configuration" },
        { path: "/docs/permissions", label: "Permissions" }
      ]
    },
    {
      title: "Features",
      items: [
        { path: "/docs/moderation", label: "Moderation" },
        { path: "/docs/utility", label: "Utility" },
        { path: "/docs/economy", label: "Economy" }
      ]
    },
    {
      title: "Premium",
      items: [
        { path: "/docs/premium/features", label: "Premium Features" },
        { path: "/docs/premium/setup", label: "Premium Setup" }
      ]
    }
  ];

  return (
    <nav className="w-64 pr-8">
      {sections.map((section, index) => (
        <div key={index} className="mb-8">
          <h3 className="text-lg font-semibold text-gray-custom-100 mb-4">{section.title}</h3>
          <ul className="space-y-2">
            {section.items.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`block px-4 py-2 rounded-lg ${
                    location.pathname === item.path
                      ? 'bg-gray-custom-700 text-white'
                      : 'text-gray-custom-400 hover:bg-gray-custom-800'
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}

function DocsContent() {
  return (
    <div className="prose prose-invert max-w-none">
      <h1>Documentation</h1>
      <p>Welcome to the Overseer documentation. Here you'll find everything you need to know about setting up and using Overseer in your Discord server.</p>
      
      <h2>Quick Start</h2>
      <p>To get started with Overseer:</p>
      <ol>
        <li>Invite the bot to your server</li>
        <li>Configure basic settings</li>
        <li>Set up permissions</li>
        <li>Start using commands!</li>
      </ol>

      <h2>Need Help?</h2>
      <p>If you need additional help, you can:</p>
      <ul>
        <li>Join our support server</li>
        <li>Check the FAQ section</li>
        <li>Contact our support team</li>
      </ul>
    </div>
  );
}

function Docs() {
  return (
    <div>
      <div className="container-custom py-24">
        <div className="flex">
          <DocsNav />
          <div className="flex-1">
            <Routes>
              <Route path="*" element={<DocsContent />} />
            </Routes>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Docs; 